import { useMemo, useState } from "react";
import { Download, Search } from "lucide-react";
import { API } from "../lib/api";
import { useProducts } from "../hooks/useProducts";
import { PageHero } from "../components/site/PageHero";
import { ProductCard } from "../components/site/ProductCard";

const CATS = ["All", "Fire Tenders", "Aerial & Rescue", "Mobile Systems", "Equipment"];

export default function Products() {
  const products = useProducts();
  const [cat, setCat] = useState("All");
  const [q, setQ] = useState("");
  const list = useMemo(() => products.filter((p) => (cat === "All" || p.category === cat) && `${p.name} ${p.tagline}`.toLowerCase().includes(q.toLowerCase())), [products, cat, q]);
  return (
    <>
      <PageHero eyebrow="Product catalog 2026" title="Fifteen platforms. One accountable maker." copy="Fire tenders, aerial and rescue vehicles, mobile mist systems and equipment — each with a downloadable spec sheet and bulk pricing on request.">
        <a className="button button-orange hero-dl" href={`${API}/catalog.pdf`} data-testid="products-catalog-download"><Download size={16} /> Full catalog PDF</a>
      </PageHero>
      <section className="section wrap catalog">
        <div className="catalog-toolbar">
          <div className="chips" role="tablist">
            {CATS.map((c) => <button key={c} className={c === cat ? "chip active" : "chip"} onClick={() => setCat(c)} data-testid={`category-filter-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{c}<span>{c === "All" ? products.length : products.filter((p) => p.category === c).length}</span></button>)}
          </div>
          <div className="search-box catalog-search"><Search /><input placeholder="Search products" value={q} onChange={(e) => setQ(e.target.value)} data-testid="product-search-input" /></div>
        </div>
        <p className="catalog-count" data-testid="product-count">{list.length} of {products.length} products</p>
        <div className="pgrid" data-testid="product-grid">{list.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}</div>
        {products.length > 0 && list.length === 0 && <div className="empty-state" data-testid="empty-products-state">No products match your search.</div>}
      </section>
    </>
  );
}
